import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environment';
import { GlobalService } from './global.service';
import { UserService } from './user.service';
import { IValidatedUser } from '@models/validated-user';
import { PageMenu } from '@models/page-menu';
import { PageSummary } from '@models/page-summary';

@Injectable({
    providedIn: 'root'
})
export class PageService {
    private baseUrl: string = environment.ApiBase + 'page/';

    constructor(
        private http: HttpClient,
        private globalService: GlobalService,
        private userService: UserService
    ) {}

    getMenu(id: string): Observable<PageMenu[]> {
        const params: HttpParams = new HttpParams({
            fromObject: { language: this.globalService.getLanguageCode() },
        });
        return this.http.get<PageMenu[]>(`${this.baseUrl}menu/${id}`, {
            params: params,
        });
    }

    getPage(id: string): Observable<PageSummary> {
        let params: HttpParams = new HttpParams();
        params = params.append('language', this.globalService.getLanguageCode());

        const currentUser: IValidatedUser = this.userService.getCurrentUser();
        if (currentUser !== undefined && currentUser !== null) {
            params = params.append('userId', currentUser.UserId); // TODO: NOT NEEDED - USE JWT TOKEN VALUE
        }

        return this.http.get<PageSummary>(`${this.baseUrl}detail/${id}`, {
            params: params,
        });
    }
}
